import './App.scss';
import { observer } from "mobx-react-lite";
import React, { useEffect } from 'react';
import { store } from './stores/Store';
import Loader from './components/Loader';
import { Modal } from './components/Modal';
import SketchfabRender from './components/SketchfabRender';
import ConfigurationSummary from './components/ConfigurationSummary';
import AccordionItem from './components/AccordionItem';
import { publicUrl } from './utils/url';
import InputQty from './components/InputQty';
import { nl2br } from './utils/Strings';
import { formatCurrency } from './utils/Currency';
import { AppTabs } from './components/AppTabs';
import { __, __t } from './utils/translation';
import { SwiperList } from './components/SwiperList';
import { nextOrFirst, prevOrLast } from './utils/ArrayUtils';
import Tooltip from './components/Tooltip';
import { Product } from './stores/Product';
import { Preloader } from './components/Preloader';


export const PUBLIC_URL = process.env.PUBLIC_URL;

const App = observer(() => {

    const cart = store.cart;

    useEffect(() => {
        store.loadConfiguration();
    }, [])

    // <Modal
    //     className="AppModal"
    //     isOpen={store.isOpen}
    //     onClose={e => {
    //         store.hideModal();
    //     }}
    // >
    return (
        <div className={`App ${store.locked ? 'App--locked' : ''} ${store.preloading ? 'App--preloading' : ''}`} >
            <Preloader visible={store.preloading} />
            <div style={{
                display: store.locked ? 'flex' : 'none'

            }} className="App__orientation-overlay">

                For the best configurator experience use it in portrait mode
            </div>
            <div className="grid">
                <div className="grid-render sticky-content--mobile">
                    <div className="sticky-content--desktop">
                        <div className="d-block d-lg-none">
                            <p className="h1-top">{__('configuring')}</p>
                            <h1 className="h1">
                                <svg width="326" height="36" viewBox="0 0 326 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_1_1994)">
                                        <path d="M0 0H13.5542V12.7059H35.7442V0H49.2544V36H35.7442V22.3054H13.5542V36H0V0Z" fill="black" />
                                        <path d="M67.3751 36H53.8271V0H86.0806C96.4397 0 101.019 3.38696 101.019 9.24239V9.77179C101.019 15.0021 96.534 17.1772 93.8609 17.8086C98.2637 18.8228 101.163 21.725 101.163 26.3749V31.6945C101.163 34.2459 101.497 35.1325 101.83 35.764V36H87.9926C87.6593 35.6173 87.565 35.1325 87.565 34.1184V29.9277C87.565 25.8136 85.6781 23.6832 80.357 23.6832H67.3751V36ZM67.3751 14.9511H82.9357C85.9422 14.9511 87.0366 13.5989 87.0366 11.8576V11.8065C87.0366 10.1162 85.9862 8.75762 82.9357 8.75762H67.3751V14.9511Z" fill="black" />
                                        <path d="M119.391 0H152.789C163.148 0 165.915 4.06307 165.915 8.17717V8.71296C165.915 13.2098 162.142 15.2445 159.808 15.7739C162.953 16.5521 167.985 18.6761 167.985 25.0163V25.5967C167.985 31.2608 164.595 36 153.003 36H119.391V0ZM132.939 8.17717V13.2799H148.663C151.474 13.2799 152.286 12.1191 152.286 10.7605V10.6648C152.286 9.26151 151.474 8.19631 148.663 8.19631L132.939 8.17717ZM132.939 21.3423V27.5358H149.543C153.078 27.5358 153.745 25.8391 153.745 24.4359V24.2892C153.745 22.7456 153.028 21.3423 149.543 21.3423H132.939Z" fill="black" />
                                        <path d="M204.515 30.1956H184.237L181.513 36H167.771L185.331 0H203.571L222.132 36H207.282L204.515 30.1956ZM194.206 8.80865L188.388 21.1956H200.206L194.206 8.80865Z" fill="black" />
                                        <path d="M238.825 0L259.437 20.4685V0H272.89V36H259.33L237.096 14.1793V36H223.636V0H238.825Z" fill="black" />
                                        <path d="M277.475 36V0H291.023V14.224L308.489 0H325.333L304.672 16.3544L326 36H308.345L291.023 19.888V36H277.475Z" fill="black" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1_1994">
                                            <rect width="326" height="36" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </h1>

                        </div>

                        <div className="Render">
                            <Loader fixed={false} zIndex={99} className='Loader__showbox--big' visible={store.pendingRequest} />
                            <SketchfabRender />
                            <button title={__('btn_view_ar')}
                                className='btn btn-orange btn-view-ar' onClick={e => {
                                    store.onCreateAr(e);
                                }}>
                                <img src={publicUrl('assets/ar.svg')} alt="" />
                                <span className='d-none d-md-inline'>
                                    {__('btn_view_in_ar')}
                                </span>
                                <span className='d-md-none'>
                                    AR
                                </span>
                            </button>
                        </div>
                        {/* {!store.isMobileDevice &&
                            <ConfigurationSummary />
                        } */}
                    </div>
                </div>
                <div className="grid-summary">

                </div>
                <div className="grid-controls">

                    <div className="d-none d-lg-block">
                        <p className="h1-top">{__('configuring')}</p>
                        <h1 className="h1 mb-0 mb-md-5">
                            <svg width="326" height="36" viewBox="0 0 326 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_1_1994)">
                                    <path d="M0 0H13.5542V12.7059H35.7442V0H49.2544V36H35.7442V22.3054H13.5542V36H0V0Z" fill="black" />
                                    <path d="M67.3751 36H53.8271V0H86.0806C96.4397 0 101.019 3.38696 101.019 9.24239V9.77179C101.019 15.0021 96.534 17.1772 93.8609 17.8086C98.2637 18.8228 101.163 21.725 101.163 26.3749V31.6945C101.163 34.2459 101.497 35.1325 101.83 35.764V36H87.9926C87.6593 35.6173 87.565 35.1325 87.565 34.1184V29.9277C87.565 25.8136 85.6781 23.6832 80.357 23.6832H67.3751V36ZM67.3751 14.9511H82.9357C85.9422 14.9511 87.0366 13.5989 87.0366 11.8576V11.8065C87.0366 10.1162 85.9862 8.75762 82.9357 8.75762H67.3751V14.9511Z" fill="black" />
                                    <path d="M119.391 0H152.789C163.148 0 165.915 4.06307 165.915 8.17717V8.71296C165.915 13.2098 162.142 15.2445 159.808 15.7739C162.953 16.5521 167.985 18.6761 167.985 25.0163V25.5967C167.985 31.2608 164.595 36 153.003 36H119.391V0ZM132.939 8.17717V13.2799H148.663C151.474 13.2799 152.286 12.1191 152.286 10.7605V10.6648C152.286 9.26151 151.474 8.19631 148.663 8.19631L132.939 8.17717ZM132.939 21.3423V27.5358H149.543C153.078 27.5358 153.745 25.8391 153.745 24.4359V24.2892C153.745 22.7456 153.028 21.3423 149.543 21.3423H132.939Z" fill="black" />
                                    <path d="M204.515 30.1956H184.237L181.513 36H167.771L185.331 0H203.571L222.132 36H207.282L204.515 30.1956ZM194.206 8.80865L188.388 21.1956H200.206L194.206 8.80865Z" fill="black" />
                                    <path d="M238.825 0L259.437 20.4685V0H272.89V36H259.33L237.096 14.1793V36H223.636V0H238.825Z" fill="black" />
                                    <path d="M277.475 36V0H291.023V14.224L308.489 0H325.333L304.672 16.3544L326 36H308.345L291.023 19.888V36H277.475Z" fill="black" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1_1994">
                                        <rect width="326" height="36" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>

                        </h1>

                    </div>
                    <AppTabs
                        items={store.categories}
                        store={store}
                        selected={store.selectedCategoryId}
                        onTabChange={(id) => {
                            store.selectCategory(id)
                        }}
                        className={'tabs1'}
                    >



                        <div className="tabs-content">
                            <div className={` ${store.subcategories.length === 0 ? 'tabs-wrapper--collapse' : ''}`}>

                                <AppTabs className={'centered tabs-content2'}
                                    onNext={e => {
                                        var item = nextOrFirst(store.subcategories, store.currentSubcategory);
                                        store.selectSubcategory(item.id);
                                    }}
                                    onPrev={e => {
                                        var item = prevOrLast(store.subcategories, store.currentSubcategory);
                                        store.selectSubcategory(item.id);
                                    }}
                                    items={store.subcategories}
                                    store={store}
                                    selected={store.selectedSubategoryId} onTabChange={(id) => {

                                        store.selectSubcategory(id)

                                    }}>

                                    <div className={`tabs-content`}>

                                        <div className="colors-list">
                                            <SwiperList
                                                activeIndex={store.currentMaterials.findIndex(el => store.isSelected(store.currentCategory.id, el.id))}
                                                key={`${store.selectedSubategoryId}_${store.selectedSubategoryId}`}
                                                items={store.currentMaterials}
                                                renderItem={(m: Product, i) => {
                                                    const isSelected = store.isSelected(store.currentCategory.id, m.id);
                                                    const twoColors = (m.channels || []).length === 2 && m.channels.some(c => c.colorFieldName === 'color2');

                                                    return <button key={m.id}
                                                        className={`Color ${m.className ? m.className : ''} ${isSelected ? ' active' : ''}`}
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            store.selectMaterial(store.currentCategory.id, m.id);
                                                        }}>
                                                        <div className="Color-lead-time">
                                                            {m.deliveryTime > 1 && <>
                                                                <span dangerouslySetInnerHTML={{ __html: __('lead_time').replace('{time}', m.deliveryTime).replace(/\n/g, '<br/>') }} />
                                                            </>}
                                                        </div>

                                                        <Tooltip title={__t(m.color_name)} key={m.id}>
                                                            <div className={`Color-icon colors-${twoColors ? 2 : 1}`}>
                                                                {
                                                                    m.channels?.map(({ thumbnail, colorFieldName }, i) => {
                                                                        return <div key={i} className={`Color-icon-inner Color-icon-inner__${colorFieldName} ${!thumbnail ? 'no-img' : 'has-img'}`}>
                                                                            {thumbnail &&
                                                                                <img className={`color-${colorFieldName}`} src={publicUrl(`/${thumbnail}`)} alt={m[colorFieldName]} />
                                                                            }
                                                                            {m.color && <>
                                                                                <div className="Color-overlay" style={{ backgroundColor: m[colorFieldName] }}></div>
                                                                                <div className="Color-overlay" style={{ backgroundColor: m[colorFieldName] }}></div>
                                                                            </>
                                                                            }

                                                                        </div>
                                                                    })
                                                                }
                                                                {!twoColors && !m.channels?.length && m.battery_icon_text && <>
                                                                    {m.name['en'] &&
                                                                        <div className="Color-name" dangerouslySetInnerHTML={{ __html: __t(m.battery_icon_text).replace(/(\\n|\n)/g, '<br>') }} />
                                                                    }
                                                                    {!m.name['en'] &&
                                                                        <div className="Color-name" dangerouslySetInnerHTML={{ __html: String(__(m.battery_icon_text)).replace(/(\\n|\n)/g, '<br>') }} />
                                                                    }
                                                                </>
                                                                }
                                                            </div>

                                                        </Tooltip>
                                                        <div className="Color-price">
                                                            {parseInt(m.price) >= 0 ? `+${formatCurrency(m.price)}` : `${formatCurrency(m.price)}`}
                                                        </div>
                                                    </button>
                                                }}>

                                            </SwiperList>


                                        </div>
                                    </div>

                                </AppTabs>
                            </div>
                        </div>

                    </AppTabs>

                    <div className="summary-cart">
                        <div className="sc-rate">
                            <div className="sc-rate__title">
                                {__('rates').replace('{months}', cart.months)}
                            </div>
                            <div className="sc-rate__price">
                                {formatCurrency(cart.installment)}
                            </div>
                        </div>
                        <div className="sc-price">
                            <div className="sc-price__total ps-md-5">{formatCurrency(cart.totalPrice)}</div>
                            <div className="sc-price__add-cart">
                                {/* <div className="sc-add-cart__amount">
                                    <InputQty value={store.quantity} onChange={val => store.updateQty(val)} />
                                </div> */}
                                <div className="sc-add-cart__btn">
                                    <button disabled={!cart.isValid} onClick={e => {
                                        store.cart.addToCart();
                                    }} className="add-to-cart-btn">
                                        {__('add_to_cart')}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="sc-info">
                            <div className="row g-0">
                                <div className="sc-info__left ps-0 ps-md-5 col-6">
                                    <p className=''>
                                        <b>{__('vat_included')}</b>
                                    </p>

                                </div>
                                <div className="sc-info__left ps-0 ps-md-5 col-6">
                                    <p>
                                        <b>{__('lead_time').replace('{time}', cart.deliveryTimeSummary)}</b>
                                    </p>

                                </div>
                            </div>
                            <div className="row g-0">
                                <div className="sc-info__left ps-0 pe-1 ps-md-5 col-6">
                                    <div dangerouslySetInnerHTML={{ __html: __('note') }}></div>
                                    <div style={{ marginTop: 5 }}>{__('disclaimer')}</div>
                                </div>
                                <div className="col-6">
                                    <img src={publicUrl('/assets/payments.png')} srcSet={`${publicUrl('/assets/payments.png')} 1x, ${publicUrl('/assets/payments@2x.png')} 2x`} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >

            <Modal
                className="ArModal"
                isOpen={store.arModalVisible && (!store.ar.response?.success)}
                onClose={e => {
                    store.hideArModal();
                }}
            >
                {store.arLoading && <>
                    <p style={{ marginTop: '2em', '--l-offset': 0 }}>
                        {__('ar_loading')}
                    </p>
                    <Loader className='static' visible={true} />
                </>}


                {!store.ar.response?.success && store.ar.response?.message}

            </Modal>


            <div className="ArModalQR" onClick={e => {
                store.hideArModal();
            }} style={{
                display: store.arModalVisible && store.ar.response?.success ? 'block' : 'none'
            }}>
                <div className="popup" style={{
                    display: store.arModalVisible && store.ar.arModelUrl ? 'block' : 'none'
                }}>

                    <div className="phone" onClick={e => e.stopPropagation()}>
                        <h1>{__('ar_header')}</h1>
                        <p>
                            {__('ar_text')}
                        </p>
                        <canvas
                            style={{
                                display: store.ar.arModelUrl ? 'block' : 'none'
                            }} rel={store.ar.arModelUrl} width={180} height={180} id="QrModalCanvas"></canvas>

                        <button type='button' onClick={e => {
                            store.hideArModal();
                        }}
                            className="btn primary hollow" id="close_popup">
                            {__('ar_close')}
                        </button>
                    </div>
                </div>
            </div>

        </div >
    )
    //  </Modal>

})
App.displayName = 'App'


export default App;
